var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone",
    transform: "translate(-325 -349)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1265",
    "data-name": "Ellipse 1265",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(325 349)",
    fill: "#39be9d",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "phone-2",
    "data-name": "phone",
    d: "M3.513,1.277a.652.652,0,0,0-.976-.061l-.994,1a1.65,1.65,0,0,0-.433,1.7,16.889,16.889,0,0,0,4.007,6.353,16.89,16.89,0,0,0,6.353,4.007,1.65,1.65,0,0,0,1.7-.433l.994-.994a.652.652,0,0,0-.061-.976l-2.218-1.725a.652.652,0,0,0-.558-.117l-2.105.526a1.678,1.678,0,0,1-1.593-.441L5.27,7.751a1.678,1.678,0,0,1-.442-1.593l.527-2.105a.652.652,0,0,0-.117-.558ZM1.811.491A1.678,1.678,0,0,1,4.322.648L6.047,2.865A1.677,1.677,0,0,1,6.35,4.3L5.824,6.407A.652.652,0,0,0,6,7.025L8.357,9.387a.652.652,0,0,0,.619.171l2.1-.526a1.678,1.678,0,0,1,1.436.3l2.217,1.725a1.677,1.677,0,0,1,.157,2.51l-.994.994a2.67,2.67,0,0,1-2.766.675,17.914,17.914,0,0,1-6.739-4.249A17.914,17.914,0,0,1,.142,4.251,2.672,2.672,0,0,1,.818,1.485L1.812.491Z",
    transform: "translate(332 356)",
    fill: "#39be9d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.9787f2523c22862f592b7084d7e9b179.svg";
export { ForwardRef as ReactComponent };